"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BugSpawnComponent = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
class BugSpawnComponent extends gotti_1.Component {
    constructor() {
        super(Constants_1.SYSTEMS.BUG_SPAWN);
    }
}
exports.BugSpawnComponent = BugSpawnComponent;
//# sourceMappingURL=module.js.map